export const RESOLVE_PROMISIFIED_ACTION = 'RESOLVE_PROMISIFIED_ACTION';
export const resolvePromisifiedAction = (isResolved, correlationId, payload) => ({
    type: RESOLVE_PROMISIFIED_ACTION,
    payload: {
        isResolved,
        correlationId,
        payload,
    },
});
//# sourceMappingURL=promisified-actions-actions.js.map